const Sidebar =() => {

    return(
        <>
        <div className="sidebar sidebar_container">
            <div className="sidebar_content">
                <div className="sidebar_head">
                    
                <h1>Category</h1>
                </div>
                <div className="sidebar_body">
                    
                <div>
            <h3>Ranker's Name</h3>
        </div>
        <div>
            <h3>Memberships</h3>
        </div>
        <div>
            <h3>Photography</h3>
        </div>
        <div>
            <h3>Random Box</h3>
        </div>
        <div>
            <h3>Gaming</h3>
        </div>
        <div>
            <h3>PFPs</h3>
        </div>
        <div>
            <h3>Art</h3>
        </div>
                </div>
                <div className="sidebar_footer">
                    
                    <h2>footer</h2>
                </div>
            </div>
        </div>
    </>
    )
}
export default Sidebar;